import styled from '@emotion/styled';

export const InfoOutlinedIcon = styled.span`
  border-radius: 50%;
  border: 1px solid currentColor;
  line-height: 0.85;
  text-align: center;
  user-select: none;

  &:before {
    content: 'i';
    display: inline;
    vertical-align: middle;
    font-size: 0.5em;
  }
`;
